import React from 'react'
import classNames from 'classnames'
import { ImageProps } from '@toasttab/shared/src/interfaces/Interface.d'

const Image = ({
  classes,
  desktopLargeImage = false,
  fullBleed = false,
  imageAlt,
  imgClasses,
  lazyLoad = true,
  optimizedImages,
  scaleHover = true,
  objectCover = true,
  title,
  url
}: ImageProps) => {
  const imageWrapperCss = classNames(classes, {
    'relative w-full p-0 overflow-hidden': objectCover,
    'md:transition-all md:duration-300 md:ease-out md:group-hover:scale-95':
      scaleHover,
    '-mx-4 md:mx-0': fullBleed,
    'lg-media': desktopLargeImage
  })

  const imageCss = classNames(imgClasses, {
    'object-cover h-full w-full': objectCover,
    'md:transition-all md:duration-300 md:ease-out scale-100 md:group-hover:scale-110':
      scaleHover,
    lazyload: lazyLoad
  })

  // todo - remove this and update alt tags below to allow empty strings
  // There are valid uses cases for empty alt text, but with the check below for imageAlt || title, we are always falling back to the title
  imageAlt = imageAlt ? imageAlt : ''

  if (optimizedImages?.srcsetAvif) {
    return (
      <div className={imageWrapperCss} data-testid='Image-srcset'>
        <picture>
          <source
            srcSet={url}
            data-srcset={url}
            data-sizes='auto'
            title={title}
          />
          <source
            srcSet={optimizedImages.srcsetAvif}
            data-srcset={optimizedImages.srcsetAvif}
            data-sizes='auto'
            type='image/avif'
            title={title}
          />
          <img
            className={imageCss}
            src={lazyLoad ? optimizedImages.placeholderBox : url}
            data-src={optimizedImages.placeholderBox}
            data-srcset={optimizedImages.srcset}
            data-sizes='auto'
            alt={imageAlt || title}
          />
        </picture>
      </div>
    )
  }
  return (
    <div className={imageWrapperCss} data-testid='Image'>
      <picture>
        {optimizedImages?.srcAvif && (
          <source srcSet={optimizedImages.srcAvif} type='image/avif' />
        )}
        {objectCover && (
          <img
            src={url}
            className={imageCss}
            alt={imageAlt || title}
            sizes='auto'
          />
        )}
        {!objectCover && (
          <img src={url} className={imageCss} alt={imageAlt || title} />
        )}
      </picture>
    </div>
  )
}

export default Image
